// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  max-width: 900px;
  width: 100%;
  min-width: 700px;
  margin: 0 auto;
}
:host .container .info {
  display: flex;
  margin-bottom: 20px;
}
:host .container .function-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}
:host .container .function-item {
  padding: 1px;
}
:host .container .function-item span {
  font-size: 13px;
  color: gray;
  margin-left: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/editor/client-script-access/client-script-access.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/editor/client-script-access/client-script-access.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;ACAR;ADEQ;EACI,aAAA;EACA,mBAAA;ACAZ;ADGQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;ACDZ;ADIQ;EACI,YAAA;ACFZ;ADKQ;EACI,eAAA;EACA,WAAA;EACA,gBAAA;ACHZ","sourcesContent":[":host {\n    .container {\n        max-width: 900px;\n        width: 100%;\n        min-width: 700px;\n        margin: 0 auto;\n\n        .info {\n            display: flex;\n            margin-bottom: 20px;\n        }\n\n        .function-list {\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n            margin-bottom: 20px;\n        }\n\n        .function-item {\n            padding: 1px;\n        }\n\n        .function-item span {\n            font-size: 13px;\n            color: gray;\n            margin-left: 6px;\n        }\n    }\n}",":host .container {\n  max-width: 900px;\n  width: 100%;\n  min-width: 700px;\n  margin: 0 auto;\n}\n:host .container .info {\n  display: flex;\n  margin-bottom: 20px;\n}\n:host .container .function-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n:host .container .function-item {\n  padding: 1px;\n}\n:host .container .function-item span {\n  font-size: 13px;\n  color: gray;\n  margin-left: 6px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
